/* Terraloo Sleek — global utilities */
(function () {
  'use strict';

  window.TerralooSleek = window.TerralooSleek || {};

  /* ---------- fade-up reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-tls-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('tls-no-animations')) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = el.getAttribute('data-tls-reveal-delay') || 0;
            setTimeout(function () {
              el.classList.add('is-visible');
            }, parseInt(delay, 10));
            io.unobserve(el);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function initRevealGroups() {
    document.querySelectorAll('[data-tls-reveal-group]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-tls-reveal-stagger') || '60', 10);
      var items = group.querySelectorAll('[data-tls-reveal]');
      items.forEach(function (item, i) {
        item.setAttribute('data-tls-reveal-delay', i * step);
      });
    });
  }

  /* ---------- scroll lock (compensates for scrollbar width to avoid layout shift) ---------- */
  var scrollLockCount = 0;
  function lockScroll() {
    if (scrollLockCount === 0) {
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        document.documentElement.style.setProperty('--tls-scrollbar-width', scrollbarWidth + 'px');
      }
      document.documentElement.classList.add('tls-scroll-lock');
    }
    scrollLockCount++;
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      document.documentElement.classList.remove('tls-scroll-lock');
    }
  }

  /* ---------- generic dialog (drawers / modals) ---------- */
  var DialogController = {
    open: function (dialog) {
      if (!dialog) return;
      lockScroll();
      dialog.setAttribute('aria-hidden', 'false');
      if (typeof dialog.showModal === 'function' && dialog.tagName === 'DIALOG') {
        try {
          dialog.showModal();
        } catch (e) {
          dialog.setAttribute('open', '');
        }
      } else {
        dialog.setAttribute('open', '');
      }
      dialog.dispatchEvent(new CustomEvent('tls:open'));
      var focusable = dialog.querySelector('[data-tls-autofocus]') || dialog.querySelector('button, [href], input, select, textarea');
      if (focusable) focusable.focus({ preventScroll: true });
    },
    close: function (dialog) {
      if (!dialog) return;
      var wasOpen = dialog.hasAttribute('open') || (dialog.tagName === 'DIALOG' && dialog.open);
      dialog.setAttribute('aria-hidden', 'true');
      if (typeof dialog.close === 'function' && dialog.tagName === 'DIALOG' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      if (wasOpen) unlockScroll();
      dialog.dispatchEvent(new CustomEvent('tls:close'));
    }
  };
  window.TerralooSleek.Dialog = DialogController;

  function initDialogTriggers() {
    document.addEventListener('click', function (e) {
      var openTrigger = e.target.closest('[data-tls-open]');
      if (openTrigger) {
        var targetId = openTrigger.getAttribute('data-tls-open');
        var target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          DialogController.open(target);
        }
      }

      var closeTrigger = e.target.closest('[data-tls-close]');
      if (closeTrigger) {
        var dialog = closeTrigger.closest('dialog, [data-tls-dialog]');
        if (dialog) {
          e.preventDefault();
          DialogController.close(dialog);
        }
      }

      var backdrop = e.target.closest('.tls-drawer__backdrop, .tls-modal__backdrop');
      if (backdrop) {
        var backdropDialog = backdrop.closest('[data-tls-dialog]');
        if (backdropDialog) DialogController.close(backdropDialog);
      }

      document.querySelectorAll('dialog[open], [data-tls-dialog][open]').forEach(function (dialog) {
        if (dialog.tagName !== 'DIALOG' && !dialog.contains(e.target) && !e.target.closest('[data-tls-open]')) {
          DialogController.close(dialog);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('dialog[open], [data-tls-dialog][open]').forEach(function (dialog) {
        DialogController.close(dialog);
      });
    });
  }

  /* ---------- header scroll state ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-tls-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-tls-menu-toggle]');
    var drawer = document.querySelector('[data-tls-mobile-drawer]');
    if (!toggle || !drawer) return;
    drawer.addEventListener('tls:open', function () {
      toggle.setAttribute('aria-expanded', 'true');
    });
    drawer.addEventListener('tls:close', function () {
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- cart count bubble sync ---------- */
  function refreshCartCount(animate) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-tls-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        if (animate) {
          document.querySelectorAll('[data-tls-cart-icon]').forEach(function (el) {
            el.classList.remove('is-bump');
            void el.offsetWidth;
            el.classList.add('is-bump');
          });
        }
      })
      .catch(function () {});
  }
  window.TerralooSleek.refreshCartCount = refreshCartCount;

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initRevealGroups();
    initDialogTriggers();
    initHeaderScroll();
    initMobileMenu();
  });
})();
